import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

// Main CSS Add
import '@/assets/app.css'
import '@/assets/css/custom.css';

import { createI18n } from 'vue-i18n'
import en from '@/assets/locales/en.json'
import es from '@/assets/locales/es.json'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

//Global validators
import { defineRule } from 'vee-validate';
import { required, email } from '@vee-validate/rules';
import { verificarCedula, verificarRuc } from "@/assets/utils/actions.js";

defineRule('required', required);

defineRule('email', email);

defineRule('terminosCondiciones', value => {
  if (!value) {
    return false;
  }
  return true;
});

defineRule('isCedula', value => {
    const validationCedula = verificarCedula(value)
    if(!validationCedula){
      return false
    }
    return validationCedula
  });
  
defineRule('isRuc', value => {
    const validationRuc = verificarRuc(value)
    if(!validationRuc){
        return false
    }
    return validationRuc
});

import { configure } from 'vee-validate';
import { localize } from '@vee-validate/i18n';

configure({
    generateMessage: localize({
        en: {
            messages: {
                required: 'This field is required',
                email: 'It must be a valid email',
                terminosCondiciones: 'You must accept the terms and conditions',
                isCedula: 'Enter a valid Ecuadorian ID. If you are a foreigner, you can select your country',
                isRuc: 'Enter a valid RUC'
            }
        },
        es: {
            messages: {
                required: 'Este campo es obligatorio',
                email: 'Debe ingresar un email válido',
                terminosCondiciones: 'Debe aceptar los términos y condiciones',
                isCedula: 'Ingrese una cédula ecuatoriana válida. Si es extranjero, puede seleccionar su país',
                isRuc: 'Ingrese un RUC válido'
            }
        }
    }),
});

import { setLocale } from '@vee-validate/i18n';
setLocale('en');

const i18n = createI18n({
    locale: 'en',
    messages: {
        en,
        es
    }
})

const app = createApp(App)

app.use(router)
app.use(i18n)
app.use(VueSweetalert2)
app.use(FloatingVue)

app.mount('#app')
